import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { GameConfigureFormContainer } from '@occc-app/routes/Game/GameConfigureForm/GameConfigureFormContainer';
import { getUpdatePageLinks as getProgramManagementUpdatePageLinks } from '@occc-app/routes/ProgramManagement/utils';
import {
  getUpdatePageLinks as getCampaignManagementUpdatePageLinks,
  useGetCampaignName,
} from '@occc-app/routes/CampaignComponents/utils';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { messages } from '../messages';

type CampaignManagementGameUpdateParams = {
  id: string;
  gameId: string;
};
export const CampaignManagementGameUpdatePageContainer = () => {
  const { id: campaignId = '', gameId = '' } = useParams<CampaignManagementGameUpdateParams>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getCampaignManagementUpdatePageLinks({
      campaignId,
      campaignComponentId: gameId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <OfferUpdatePageContainer
      campaignId={campaignId}
      offerId={gameId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.FreeGame}
      showExternalUrl
      ignoreConfigureFormSubmit
      ConfigureFormContainer={GameConfigureFormContainer}
    />
  );
};

type ProgramManagementGameUpdateParams = {
  id: string;
  offerId: string;
};
export const ProgramManagementGameUpdatePageContainer = () => {
  const { offerId = '' } = useParams<ProgramManagementGameUpdateParams>();
  const isUserPermittedToEditGames = useIsUserPermittedTo(Feature.GAME_EDIT);

  const breadcrumbLinks = (offerName: string) => {
    const pageTitle = isUserPermittedToEditGames ? offerName : 'Game Configurations';

    return getProgramManagementUpdatePageLinks({
      offerId,
      offerName: pageTitle,
      offerType: OfferType.VoucheredGame,
    });
  };

  return (
    <OfferUpdatePageContainer
      offerId={offerId}
      getBreadcrumbLinks={breadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.VoucheredGame}
      ConfigureFormContainer={GameConfigureFormContainer}
      showSurgeonGeneralsWarning={false}
    />
  );
};
